export const ORBIT_ITEM_ICONS = [
  {
    iconCode: 'f004',
    icon: 'fa fa-heart',
    matIcon: 'favorite',
  },
  {
    iconCode: 'f109',
    icon: 'fa fa-laptop',
    matIcon: 'laptop',
  },
  {
    iconCode: 'f007',
    icon: 'fa fa-user',
    matIcon: 'person',
  },
  {
    iconCode: 'f041',
    icon: 'fa fa-map-marker',
    matIcon: 'location_on',
  },
  {
    iconCode: 'f0c0',
    icon: 'fa fa-users',
    matIcon: 'groups',
  },
  {
    iconCode: 'f0c2',
    icon: 'fa fa-cloud',
    matIcon: 'cloud',
  },
  {
    iconCode: 'f1eb',
    icon: 'fa fa-wifi',
    matIcon: 'wifi',
  },
  {
    iconCode: 'f10b',
    icon: 'fa fa-mobile',
    matIcon: 'phone_iphone',
  },
  {
    iconCode: 'f128',
    icon: 'fa fa-question',
    matIcon: 'help',
  },
  {
    iconCode: 'f005',
    icon: 'fa fa-star',
    matIcon: 'star',
  },
];
